import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectActivityActions from './project-activity.actions';
import { ProjectActivityService } from '../../services/project-activity.service';
import { Router } from '@angular/router';

@Injectable()
export class ProjectActivityEffects {
  loadProjectActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActivityActions.loadProjectActivity),
      exhaustMap((_) =>
        this.projectActivityService.getProjectActivity().pipe(
          map((data) =>
            ProjectActivityActions.loadProjectActivitySuccess({
              projectActivity: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProjectActivityActions.loadProjectActivityFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProjectActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActivityActions.addProjectActivity),
      concatMap(({ newProjectActivity }) =>
        this.projectActivityService
          .createProjectActivity(newProjectActivity)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProjectActivityActions.addProjectActivitySuccess({
                newProjectActivity: data,
              });
            }),
            catchError((error) => {
              console.log('error ', error);

              return of(
                ProjectActivityActions.addProjectActivityFailure({
                  error: error.error.message,
                })
              );
            })
          )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProjectActivityActions.addProjectActivitySuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProjectActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActivityActions.updateProjectActivity),
      concatMap(({ updateProjectActivity }) =>
        this.projectActivityService
          .updateProjectActivity(updateProjectActivity)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProjectActivityActions.updateProjectActivitySuccess({
                updateProjectActivity: data,
              });
            }),
            catchError((error) => {
              return of(
                ProjectActivityActions.updateProjectActivityFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectActivityActions.updateProjectActivitySuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProjectActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActivityActions.removeProjectActivity),
      map((action) => action.ids),
      concatMap((ids) =>
        this.projectActivityService.deleteProjectActivity(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProjectActivityActions.removeProjectActivitySuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProjectActivityActions.updateProjectActivityFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectActivityService: ProjectActivityService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
